import axios from "axios";

export const getToken = () => {
  let token = sessionStorage.getItem("token");
  return token;
};

const attachAuthInterceptor = (instance) => {
  instance.interceptors.response.use(
    (response) => {
      try {
        const refreshedToken =
          response.headers?.["x-refreshed-token"] ||
          response.headers?.["x-access-token"] ||
          response.headers?.["authorization"];
        if (refreshedToken) {
          sessionStorage.setItem("token", refreshedToken);
        }

        const refreshedPermToken =
          response.headers?.["x-refreshed-permissiontoken"] ||
          response.headers?.["permissiontoken"];
        if (refreshedPermToken) {
          sessionStorage.setItem("permissiontoken", refreshedPermToken);
        }
      } catch (e) {
        // ignore storage errors in environments without sessionStorage
      }
      return response;
    },
    (error) => {
      if (error?.response) {
        const status = error.response.status;
        const errMsg = error.response.data?.errors || error.response.data?.message;
        if (
          status === 401 &&
          (errMsg === "This user has been deactivated by the Admin. Please contact your Admin." ||
            errMsg === "Please authenticate" ||
            errMsg === "Invalid User" ||
            errMsg === "Session expired. Please log in again.")
        ) {
          // public share pages (/view/<token>) work without login – never send them to the login page
          if (/^\/view\//.test(window.location.pathname)) return Promise.reject(error);
          sessionStorage.clear();
          localStorage.clear();
          if (errMsg === "This user has been deactivated by the Admin. Please contact your Admin.") {
            alert(errMsg);
          }
          window.location.href = "/login";
        }
      }
      return Promise.reject(error);
    }
  );
  return instance;
};

export const getAxios = () => {
  const token = getToken();
  const headers = {
    "Content-Type": "application/json",
    Authorization: `${token}`,
  };
  const instance = axios.create({ headers });
  return attachAuthInterceptor(instance);
};

export const getAxiosMultipart = () => {
  const token = getToken();
  const headers = { Authorization: `${token}` };
  const instance = axios.create({ headers });
  return attachAuthInterceptor(instance);
};
export function convertTo12HourFormat(time24Hour) {
  const [hours, minutes] = time24Hour.split(":").map(Number); // Parse hours and minutes as integers
  const period = hours >= 12 ? "PM" : "AM";
  const hours12 = hours % 12 || 12;
  return `${hours12}:${minutes < 10 ? "0" : ""}${minutes} ${period}`;
}
